<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <h2>{{ $t('满赠库存') }}</h2>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="8" :sm="24"><a-form-item :label="$t('活动名称')"><a-input v-model="queryParam.activityName" :placeholder="$t('请输入活动名称')" allow-clear @pressEnter="handleQuery" /></a-form-item></a-col>
            <a-col :md="8" :sm="24"><a-form-item :label="$t('活动 ID')"><a-input-number v-model="queryParam.activityId" :min="1" :precision="0" style="width:100%" /></a-form-item></a-col>
            <a-col :md="8" :sm="24"><a-button type="primary" @click="handleQuery"><a-icon type="search" /> {{ $t('查询') }}</a-button><a-button style="margin-left:8px" @click="resetQuery"><a-icon type="redo" /> {{ $t('重置') }}</a-button></a-col>
          </a-row>
        </a-form>
      </div>
      <a-alert :message="$t('库存页面仅供查询；库存调整请在满赠活动列表对进行中的活动使用“增加库存”。')" type="info" show-icon style="margin-bottom:16px" />
      <a-table
        row-key="tierId"
        :loading="loading"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :scroll="{x: 1300}"
      >
        <template slot="giftSkus" slot-scope="skus"><div v-for="sku in skus" :key="sku.skuId">{{ sku.goodsName }} / {{ sku.skuName }}（SKU {{ sku.skuId }}）</div></template>
        <template slot="giftQuantity" slot-scope="skus"><div v-for="sku in skus" :key="sku.skuId">{{ sku.giftQuantity }}</div></template>
        <template slot="updateTime" slot-scope="text">{{ parseTime(text) }}</template>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :total="total"
        :show-total="value => `${$t('共')}${value}${$t('条')}`"
        @change="changePage"
        @showSizeChange="changePage"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageFullGiftStock } from '@/api/activity/fullGift'

export default {
  name: 'FullGiftStock',
  data () {
    return {
      loading: false,
      list: [],
      total: 0,
      queryParam: { activityId: undefined, activityName: undefined, pageNum: 1, pageSize: 10 },
      columns: [
        { title: this.$t('活动'), dataIndex: 'activityName', width: 160 },
        { title: this.$t('阶梯门槛'), dataIndex: 'thresholdAmount', width: 100 },
        { title: this.$t('总库存'), dataIndex: 'totalStock', width: 90 },
        { title: this.$t('累计发放'), dataIndex: 'issuedCount', width: 90 },
        { title: this.$t('剩余库存'), dataIndex: 'remainingStock', width: 90 },
        { title: this.$t('赠品 SKU 快照'), dataIndex: 'giftSkus', width: 280, scopedSlots: { customRender: 'giftSkus' } },
        { title: this.$t('赠送数量'), dataIndex: 'giftSkus', width: 100, scopedSlots: { customRender: 'giftQuantity' } },
        { title: this.$t('限领'), dataIndex: 'receiveLimit', width: 80 },
        { title: this.$t('更新时间'), dataIndex: 'updateTime', width: 180, scopedSlots: { customRender: 'updateTime' } }
      ]
    }
  },
  created () { this.getList() },
  methods: {
    getList () {
      this.loading = true
      pageFullGiftStock(this.queryParam).then(response => {
        this.list = response.data.records || []
        this.total = Number(response.data.total || 0)
      }).finally(() => { this.loading = false })
    },
    handleQuery () { this.queryParam.pageNum = 1; this.getList() },
    resetQuery () { this.queryParam = { activityId: undefined, activityName: undefined, pageNum: 1, pageSize: 10 }; this.getList() },
    changePage (pageNum, pageSize) { this.queryParam.pageNum = pageNum; this.queryParam.pageSize = pageSize; this.getList() }
  }
}
</script>
